// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"f7fa6029","560":"f7fa6029"}[chunkId] + ".chunk.css";
};